import * as z from 'zod';

const requireTrue = (message: string) =>
  z
    .union([z.literal(true), z.literal('true')], { error: message })
    .transform((val) => val === true || val === 'true')
    .refine((val) => val === true, {
      message,
    });

export default requireTrue;
